import { z } from 'zod';

export const VehicleClassSchema = z.object({
    id: z.number(),
    identifier: z.string(),
    name: z.string(),
    numAxes: z.number(),
    // NOTE: the payload & payloadMax values are in "KG"
    payload: z.number(),
    payloadMax: z.number(),
    payloadInTons: z.number(),
});

export type VehicleClass = z.infer<typeof VehicleClassSchema>;
